import React from "react";

import { Box } from "app/layout/components";
import { SelectableColumnTable } from "app/interaction/SelectableColumnTable/SelectableColumnTable";
import { AnnualKeyData as Data } from "./annualKeyDataModel";

import "./style.scss";
import { FinanceKnowledgeContainer } from "app/financeKnowledge/FinanceKnowledgeContainer/FinanceKnowledgeContainer";
import { SectionHeader } from "app/layout/SectionHeader/SectionHeader/SectionHeader";
import { getHeadline, prepareKeyData } from "app/shares/AnnualKeyData/functions";

export interface KeyDataTableProps {
    /** Name of the asset, e.g. Daimler */
    assetName: string;
    currency: string;
    children: Data[];
}

const rowLabels = ["Dividendenrendite", "Dividende je Aktie", "KGV", "KBV"];

/**
 * Renders a table that shows the key data for an instrument for five years.
 * On mobile, the table shows only the values for _one_ year and alongside
 * a button component to select the year.
 */
export const AnnualKeyData = ({ assetName, currency, children }: KeyDataTableProps) => {
    return (
        <Box section>
            <SectionHeader headline={getHeadline(assetName)} />
            <FinanceKnowledgeContainer knowledgeKey="whatAreKeyFigures" />
            <SelectableColumnTable rowLabels={rowLabels}>{prepareKeyData(children, currency)}</SelectableColumnTable>
            <p className={"disclaimerHint"}>* enthält Prognose von FactSet</p>
        </Box>
    );
};
